module.exports = __webpack_public_path__ + "img/B116.ba4a9a79.jpg";